export const products = [
  {
    id: '1',
    name: '200ml Bottle',
    size: '200ml',
    price: 15.00,
    description: 'Perfect for pancakes and personal use. Our handcrafted maple syrup in a convenient size.',
    image: 'https://images.unsplash.com/photo-1571942676516-bcab84649e44?w=800&q=80',
    inStock: false
  },
  {
    id: '2',
    name: '350ml Bottle',
    size: '350ml',
    price: 25.00,
    description: 'Our most popular size. Ideal for families and maple syrup enthusiasts.',
    image: 'https://images.unsplash.com/photo-1604968090956-350e67f9e93b?w=800&q=80',
    inStock: false
  },
  {
    id: '3',
    name: '1 Gallon Jug',
    size: '1 Gallon',
    price: 70.00,
    description: 'For true maple lovers. Bulk size perfect for restaurants or syrup connoisseurs.',
    image: 'https://images.unsplash.com/photo-1563371175-0bbc4f6f4e96?w=800&q=80',
    inStock: false
  }
];

export const faqData = [
  {
    question: 'How is your maple syrup made?',
    answer: 'Our maple syrup is handcrafted using traditional methods passed down through generations. We tap maple trees in Upstate NY during the spring season and carefully boil the sap to create pure, Grade A maple syrup.'
  },
  {
    question: 'How should I store my maple syrup?',
    answer: 'Unopened bottles can be stored in a cool, dry place. Once opened, refrigerate your maple syrup to maintain freshness. It will last 6-12 months in the refrigerator.'
  },
  {
    question: 'Do you ship nationwide?',
    answer: 'Yes! We ship our maple syrup across the United States. Orders typically arrive within 5-7 business days.'
  },
  {
    question: 'What makes your maple syrup special?',
    answer: 'We are a small family operation that takes pride in every batch. Our syrup is 100% pure, contains no additives, and is harvested sustainably from our own maple grove in Upstate New York.'
  },
  {
    question: 'What grade is your maple syrup?',
    answer: 'We produce Grade A maple syrup in various amber grades, depending on when it was harvested during the season. Each bottle is labeled with its specific grade and harvest date.'
  },
  {
    question: 'How much sap does it take to make maple syrup?',
    answer: 'It takes approximately 40 gallons of raw maple sap to make just 1 gallon of pure maple syrup! That\'s a lot of boiling and a whole lot of love. Nature really makes us work for that liquid gold!'
  },
  {
    question: 'Can I visit your sugarhouse?',
    answer: 'We love visitors! During maple season (late February through April), we occasionally open our sugarhouse for tours. Contact us to check availability and schedule a visit to see the magic happen firsthand!'
  },
  {
    question: 'Why is maple syrup tapped in late winter/early spring?',
    answer: 'Maple sap flows best when temperatures drop below freezing at night and rise above freezing during the day. This temperature swing creates pressure that pushes the sap up through the tree. It\'s nature\'s perfect timing!'
  },
  {
    question: 'Is maple syrup healthier than regular sugar?',
    answer: 'Maple syrup contains antioxidants and minerals like manganese and zinc that refined sugar doesn\'t have. While it\'s still a sweetener and should be enjoyed in moderation, it\'s a more natural alternative with added nutrients!'
  }
];

export const aboutContent = {
  title: 'Our Story',
  story: 'The Maple Daddies began as a passion project in the heart of Upstate New York. What started as a family tradition of tapping a few backyard maple trees has grown into a full-fledged sugarhouse operation. We believe in sustainable harvesting, traditional methods, and creating the finest maple syrup that brings families together around the breakfast table.',
  location: 'Nestled in the beautiful forests of Greenwich, NY, our sugarhouse is surrounded by towering maples and the sounds of nature. The crisp mountain air, babbling brooks, and miles of forest trails make this the perfect place to craft pure maple syrup. During peak season from late February through April, the cold nights and warm days create ideal conditions for sap flow, resulting in the rich, sweet syrup we\'re known for.',
  team: 'We\'re Marco and Adam, a married couple who found our passion in the great outdoors and nature. What began as tapping a few trees for personal use turned into a dream come true - our own maple syrup brand. We\'re proud to make a product fully by hand with no additives or chemicals, just pure 100% maple syrup. From tapping and collecting to boiling and bottling, every step is done by hand with love and dedication to quality.'
};